import { TrainingStatus } from './TrainingStatus'

export default TrainingStatus
